export const getApiUrl = () =>
  process.env.REACT_APP_LOCAL_MODE === 'true'
    ? process.env.REACT_APP_LOCAL_SERVER_URL
    : process.env.REACT_APP_API_URL || 'https://dev-api.tornado.com';
